export const addFiltersToUrl = (url: string, urlSearchParams: URLSearchParams) => {
  let modifiedUrl = url;
  let firstParam = true;

  urlSearchParams.forEach((value, key) => {
    if (firstParam) {
      modifiedUrl += '?';
    } else {
      modifiedUrl += '&';
    }
    modifiedUrl += `${key === 'spaceId' ? 'spaceIds' : key}=${value}`;
    firstParam = false;
  });
  return modifiedUrl;
};
